<template>
  <section>
    <qx-search-box
      class="searchBox"
      :searchBoxData="searchBoxData"
      @sub="sub"
      @reset="reset"
      ref="searchBox"
      title="筛选"
      permpisionsQuery=""
    />
    <TableBox ref="tableBox" />
  </section>
</template>

<script>
import TableBox from './tableBox';
import {
  getDepartmentAllList,
  getEnumList,
} from 'api';
import {
  roleList,
} from 'api/system';
export default {
  components: {
    TableBox,
  },
  data () {
    return {
      searchBoxData: {
        roleIdOptions: [],
        lockFlagOptions: [],
        orgIdOptions: [],
        form: [
          { // 角色权限
            label: '角色权限',
            value: 'roleId',
            type: 'select',
            default: this.$route.query.roleId,
            placeholder: '请选择角色权限',
          },
          { // 登录手机
            label: '登录手机',
            value: 'loginAcct',
            type: 'input',
            placeholder: '请输入登录手机',
          },
          { // 员工姓名
            label: '员工姓名',
            value: 'linkman',
            type: 'input',
            placeholder: '请输入员工姓名',
          },
          { // 员工工号
            label: '员工工号',
            value: 'employeeNumber',
            type: 'input',
            placeholder: '请输入员工工号',
          },
          { // 归属部门
            label: '归属部门',
            value: 'orgId',
            type: 'select',
            placeholder: '请选择归属部门',
            default: -1,
          },
          { // 员工职位
            label: '员工职位',
            value: 'staffPosition',
            type: 'input',
            placeholder: '请输入员工职位',
          },
          { // 账号状态
            label: '账号状态',
            value: 'lockFlag',
            type: 'select',
            placeholder: '请选择账号状态',
            default: -1,
          },
        ],
      },
    };
  },
  watch: {
    '$route.query.roleId': function (newVal) {
      if (this.$route.path === '/manage/system/jurisdiction/worker' && newVal) {
        this.$refs.searchBox.setVal('roleId', newVal);
        this.$refs.searchBox.sub();
      }
    },
  },
  methods: {
    reset (val) {
      if (val === 'reset') {
        this.$refs.searchBox.setVal('roleId', '');
      }
    },

    /**
     * @param {object} searchBoxData 搜索栏数据
     * @returns {void}
     * @description 搜索栏触发搜索事件，将数据传递给表格box进行保存并刷新数据
     */
    sub (searchBoxData) {
      this.$refs.tableBox.saveSearchBoxData(searchBoxData);
    },
  },
  async created () {
    const enumsList = await getEnumList({
      codeType: 'ZH_USER_STATE',
    });
    const safeEnum = (index) => (Array.isArray(enumsList) && Array.isArray(enumsList[index])) ? enumsList[index] : [];
    this.searchBoxData.lockFlagOptions = [
      {
        label: '全部',
        value: -1,
      },
      ...safeEnum(0),
    ];
    this.searchBoxData.orgIdOptions = [
      {
        label: '全部',
        value: -1,
      },
      ...((await getDepartmentAllList({
        pid: -2,
      })) || []),
    ];
    const roleRes = await roleList({
      page: 1,
      rows: 100000,
    });
    const roleItems = Array.isArray(roleRes && roleRes.items) ? roleRes.items : [];
    this.searchBoxData.roleIdOptions = [
      {
        label: '全部',
        value: -1,
      },
      ...roleItems.map((item) => ({
        label: item.roleName,
        value: String(item.roleId),
      })),
    ];
  },
};
</script>

<style lang="scss" scoped>
</style>
